import { render } from "./TermWidget.vue?vue&type=template&id=87c68bf6"
import script from "./TermWidget.vue?vue&type=script&lang=js"
export * from "./TermWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Dashboard/TermWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "87c68bf6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('87c68bf6', __exports__)) {
    api.reload('87c68bf6', __exports__)
  }
  
  module.hot.accept("./TermWidget.vue?vue&type=template&id=87c68bf6", () => {
    api.rerender('87c68bf6', render)
  })

}


export default __exports__